export default __webpack_public_path__ + "static/media/etheriumlogo.e06b5de5.svg";